import { useContext, useState } from "react";

import Button from "../../components/Button/Button";
import Checkbox from "../../components/Checkbox/Checkbox";
import Label from "../../components/Label/Label";
import SignatureCanvas from "../../components/SignatureCanvas/SignatureCanvas";
import Header from "../../components/Header/Header";
import NavigationButtons from "../../components/NavigationButtons/NavigationButtons";

import ReloadIcon from "../../assets/icons/reload.svg";

import { ContractContext } from "../../context/contract";
import { AuthContext } from "../../context/auth";

import { SIGNATURE_TYPE } from "./constants";

import "./styles.scss";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";

const AgentSignature = () => {
  const { formData, handleFormData, createContract, loading } =
    useContext(ContractContext);
  const { prospectId } = useContext(AuthContext);

  const [error, setError] = useState(false);

  const onClearButtonClick = (type: string) => {
    switch (type) {
      case SIGNATURE_TYPE.AGENT: {
        formData?.agentSignatureCanvas?.clear();
        handleFormData({
          ...formData,
          agentSignature: "",
          agentSignatureTime: "",
        });
        break;
      }
      case SIGNATURE_TYPE.WITNESS: {
        formData?.witnessSignatureCanvas?.clear();
        handleFormData({
          ...formData,
          witnessSignature: "",
        });
        break;
      }
      default: {
        return "";
      }
    }
  };

  const onDrawEnd = (e: any, type: string) => {
    handleFormData({
      ...formData,
      ...(type === SIGNATURE_TYPE.AGENT && {
        agentSignatureCanvas: e,
        agentSignature: e?.getTrimmedCanvas()?.toDataURL("image/png"),
        agentSignatureTime: new Date().toISOString(),
      }),
      ...(type === SIGNATURE_TYPE.WITNESS && {
        witnessSignatureCanvas: e,
        witnessSignature: e?.getTrimmedCanvas()?.toDataURL("image/png"),
      }),
    });
  };

  const handleNextButtonClick = () => {
    const {
      customerSignature,
      agentSignature,
      witnessSignature,
      agentWitnessSignTnC,
      agentSignatureCanvas,
      witnessSignatureCanvas,
    } = formData;
    if (
      agentSignature &&
      witnessSignature &&
      agentWitnessSignTnC &&
      agentSignatureCanvas &&
      witnessSignatureCanvas
    ) {
      createContract({
        prospectId,
        agentSignature,
        witnessSignature,
        customerSignature,
        agentWitnessSignTnC,
      });
      return;
    }
    return setError(true);
  };

  return (
    <>
      <Header />
      <div className="signature-container">
        <div className="witness-signature-wrapper">
          <Label
            required
            label="Signature of Witness"
            className="d-flex justify-between items-center"
            dynamicContent={
              <div>
                <Button
                  icon={ReloadIcon}
                  subType="icon"
                  type="button"
                  name=""
                  disabled={!formData?.witnessSignature}
                  onClick={() => onClearButtonClick(SIGNATURE_TYPE.WITNESS)}
                />
              </div>
            }
          />
          <div className="signature-canvas-wrapper">
            <SignatureCanvas
              onDrawEnd={(e: any) => onDrawEnd(e, SIGNATURE_TYPE.WITNESS)}
              {...(error &&
                !formData?.witnessSignature && {
                  error: "This field is required.",
                })}
            />
          </div>
        </div>
        <div className="agent-signature-wrapper">
          <Label
            required
            label="Signature of Agent"
            className="d-flex justify-between items-center"
            dynamicContent={
              <div>
                <Button
                  icon={ReloadIcon}
                  subType="icon"
                  type="button"
                  name=""
                  disabled={!formData?.agentSignature}
                  onClick={() => onClearButtonClick(SIGNATURE_TYPE.AGENT)}
                />
              </div>
            }
          />
          <div className="signature-canvas-wrapper">
            <SignatureCanvas
              onDrawEnd={(e: any) => onDrawEnd(e, SIGNATURE_TYPE.AGENT)}
              {...(error &&
                !formData?.agentSignature && {
                  error: "This field is required.",
                })}
            />
          </div>
        </div>
        <Checkbox
          title="I have agree to share my signature with Sun King for processing my loan application"
          defaultValue={formData.agentWitnessSignTnC}
          handleCheckboxChange={(value: boolean) => {
            handleFormData({
              ...formData,
              agentWitnessSignTnC: value,
            });
          }}
          {...(error && !formData.agentWitnessSignTnC
            ? {
                error: "This field is required.",
              }
            : {})}
        />
      </div>
      <NavigationButtons handleNextButtonClick={handleNextButtonClick} />
      {loading && <FullPageLoader />}
    </>
  );
};

export default AgentSignature;
